/**
 * @generated SignedSource<<c3cb69e1c9ec49dc353a6348948884c9>>
 * @relayHash f7ebae2d84a308b13c63cf480c4c31de
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/458.0.0-2024-04-17T07:16:37.070Z/CustomsMessagingRendererQuery

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CustomsMessagingRendererQuery$variables = {
  destinationCountry?: string | null;
  itemId?: string | null;
  userId?: string | null;
};
export type CustomsMessagingRendererQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"CustomsMessagingBody_viewer">;
  };
};
export type CustomsMessagingRendererQuery = {
  response: CustomsMessagingRendererQuery$data;
  variables: CustomsMessagingRendererQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "destinationCountry"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "itemId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CustomsMessagingRendererQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CustomsMessagingBody_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "CustomsMessagingRendererQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "buyerId",
                "variableName": "userId"
              },
              {
                "kind": "Variable",
                "name": "destinationCountry",
                "variableName": "destinationCountry"
              },
              {
                "kind": "Variable",
                "name": "itemId",
                "variableName": "itemId"
              }
            ],
            "concreteType": "CustomsDuties",
            "kind": "LinkedField",
            "name": "customsDuties",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "duties",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/458.0.0-2024-04-17T07:16:37.070Z/CustomsMessagingRendererQuery",
    "metadata": {},
    "name": "CustomsMessagingRendererQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "8724964c718b0ab7a0e446e53f72df3c";

export default node;
